import { PiSpinnerGapBold } from "react-icons/pi";

/**
 * Markup copied from vendor/isomorphic/packages/isomorphic-core/src/ui/upload.tsx's own default
 * `placeholderText` fallback (the same file `@steelyard/theme`'s `src/ui/upload.tsx` copies
 * verbatim, per CLAUDE.md's copied-file rule). That vendor file reads "browse thorough your
 * machine" — a typo in the vendor's own copy — and may only receive CLAUDE.md's permitted
 * mechanical de-Nexting edits, so the fix lives here instead: the same markup/classes, passed in
 * as `placeholderText`, with the wording corrected to "through".
 */
export function UploadDropHint() {
  return (
    <div className="pt-1 text-center @2xl:ps-3 @2xl:text-left">
      <h5 className="mb-1 text-sm font-semibold text-gray-900">Drop or select file</h5>
      <p className="text-xs leading-relaxed text-gray-500">
        Drop files here or click{" "}
        <span className="font-semibold text-gray-900 underline hover:no-underline">browse</span> through your machine
      </p>
    </div>
  );
}

/**
 * The eight `<Upload>` call sites in this app all swapped `placeholderText` for a bare
 * `<Text>Uploading…</Text>` while a file was in flight — losing the dropzone's own icon and
 * giving no sense that anything was actually happening. This keeps the same slot but with a
 * spinner in place of the static icon, so "busy" reads as busy rather than as a content flash.
 */
export function UploadBusyHint({ label }: { label: string }) {
  return (
    <div className="flex items-center justify-center gap-2 pt-1 text-center @2xl:justify-start @2xl:ps-3 @2xl:text-left">
      <PiSpinnerGapBold aria-hidden className="size-4 shrink-0 animate-spin text-gray-400" />
      <p className="text-sm font-medium text-gray-900">{label}</p>
    </div>
  );
}
